import Commissions from 'Agent/Commissions/components/Commissions';
import CommissionSchedules from 'Agent/Commissions/components/Schedules/CommissionSchedules';
import React from 'react';
import {Route, RouteComponentProps, Switch} from 'react-router-dom';
import {AgencyFilters} from 'Shared/models/AgencyFilters';

type CommissionsRouteProps = {
  selectedAgency: AgencyFilters;
} & RouteComponentProps;

export default ({match, selectedAgency}: CommissionsRouteProps) => (
  <Route
    path={`${match.url}/commissions`}
    render={routeProps => (
      <Switch>
        <Route
          path={`${routeProps.match.url}/schedules`}
          render={() => <CommissionSchedules selectedAgency={selectedAgency} />}
        />
        <Route
          path={`${routeProps.match.url}`}
          render={() => <Commissions {...routeProps} selectedAgency={selectedAgency} />}
        />
      </Switch>
    )}
  />
);
